import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';
import { AutoLoginService } from 'src/app/services/auto-login.service';
import { ServerUrlService } from 'src/app/services/server-url.service';

@Component({
	selector: 'app-auto-login',
	templateUrl: './auto-login.component.html',
	styleUrls: ['./auto-login.component.scss']
})
export class AutoLoginComponent implements OnInit {

	private token

	constructor(
		private activatedRoute: ActivatedRoute,
		private autoLoginService: AutoLoginService,
		private authService: AuthService,
		private serverUrlService: ServerUrlService,
		private router: Router,
		private snackBar: MatSnackBar,
	) {

	}

	ngOnInit() {
		this.token = this.activatedRoute.snapshot.params.token;
		this.verifyToken()
	}

	verifyToken() {
		sessionStorage.clear();
		this.authService.logOutUser();
		this.autoLoginService.verifyToken(this.token).subscribe(
			(response) => {
				sessionStorage.setItem('userData', JSON.stringify(response));
				this.authService.setUser(response)
				this.router.navigate(['/' + this.serverUrlService.getName() + '/client/agendamento']);
			},
			(err) => {
				this.snackBar.open("Erro ao fazer o login", "", { duration: 5000 })
			}
		)
	}
}
